import { EHttpErrorCode } from "@/configuration/errorHandler/types";

const HTTP_ERROR_MESSAGES: Record<EHttpErrorCode, string> = {
  [EHttpErrorCode.BAD_REQUEST]: 'common.error',
  [EHttpErrorCode.UNAUTHORIZED]: 'common.auth.error',
  [EHttpErrorCode.FORBIDDEN]: 'common.auth.error',
  [EHttpErrorCode.NOT_FOUND]: 'common.error',
  [EHttpErrorCode.UNPROCESSABLE_ENTITY]: 'common.error',
  [EHttpErrorCode.GATEWAY_TIMEOUT]: 'common.error',
  [EHttpErrorCode.SERVER_ERROR]: 'common.error',
};

const DEFAULT_ERROR_MESSAGE = 'common.error';

/**
 * Returns a user-facing error message for a given HTTP error code.
 *
 * @param code - An {@link EHttpErrorCode} value.
 * @returns A descriptive error message string. Falls back to a generic message if the code is not explicitly mapped.
 */
export const getHttpErrorMessage = (code: EHttpErrorCode): string => {
  return HTTP_ERROR_MESSAGES[code] ?? DEFAULT_ERROR_MESSAGE;
};
